import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Collapsible, Box } from "@bca/ui-library";

export interface FilterProps {
  id: string;
  label: string;
  resultsCount: number;
  categoryId: string;
  isSelected: boolean;
  section?: string;
}
export interface CollapsibleSectionProps {
  title: string;
  isDisabled?: boolean;
  children?: any;
  onRemoveFilter?: (filterId: string, categoryId: string) => void;
  categoryKey: string;
  setCurrentFacet: (string) => void;
  currentFacet: string;
  chipsSlot: any;
  setQuery: (string) => void;
}

export const CollapsibleFacet = ({
  title,
  isDisabled = false,
  children,
  categoryKey,
  setCurrentFacet,
  currentFacet,
  chipsSlot,
  setQuery,
}: CollapsibleSectionProps) => {
  const [isClosed, setIsClosed] = useState(currentFacet !== "VehicleType");
  const ref = useRef(null);

  const handleOnChange = (isClosed: boolean) => {
    setCurrentFacet(categoryKey);
    setIsClosed(isClosed);

    if (typeof ref.current.scrollIntoView === "function") {
      ref.current.scrollIntoView();
    }

    setQuery("");
  };

  useEffect(() => {
    if (isDisabled) {
      setIsClosed(isDisabled);
    }
  }, [isDisabled]);

  const isCollapsed = categoryKey !== currentFacet || isClosed;

  return (
    <Box
      ref={ref}
      data-testid="collapsible-facet"
      mb={!isClosed && categoryKey === currentFacet && 5}
    >
      <Collapsible
        title={title}
        disabled={isDisabled}
        closed={isCollapsed}
        onChange={(event: ChangeEvent<unknown>, isClosed: boolean) =>
          handleOnChange(isClosed)
        }
      >
        {!isCollapsed && children}
      </Collapsible>
      {isCollapsed && chipsSlot}
    </Box>
  );
};
